var map = {
	"./H5/about.png": "1230",
	"./H5/arrow.png": "9b77",
	"./H5/back.png": "b6a9",
	"./H5/banner.jpg": "7a08",
	"./H5/disclaimer.png": "bc30",
	"./H5/games-1.png": "f5d3",
	"./H5/games-2.png": "de84",
	"./H5/global-1.png": "763d",
	"./H5/global-2.png": "6ab7",
	"./H5/home-1.png": "4a2f",
	"./H5/home-2.png": "a908",
	"./H5/icons8_memories.png": "26f0",
	"./H5/imageLib-button.png": "93e4",
	"./H5/link.png": "775e",
	"./H5/liveStream.png": "7cec",
	"./H5/liveStreamClose.png": "98ac",
	"./H5/logo.png": "7557",
	"./H5/menu.png": "4328",
	"./H5/return-1.png": "d49b",
	"./H5/return-2.png": "85ad",
	"./H5/statistics-1.png": "9b01",
	"./H5/statistics-2.png": "b069",
	"./H5/user-1.png": "bba0",
	"./H5/user-2.png": "da26",
	"./H5/volume.png": "878f",
	"./_bar1.png": "e333",
	"./_bar2.png": "39e3",
	"./about.png": "ce1b",
	"./ballicon/azxy10_icon.png": "f96a",
	"./ballicon/azxy20_icon.png": "bd5d",
	"./ballicon/azxy5_icon.png": "492c",
	"./ballicon/azxy8_icon.png": "6011",
	"./ballicon/cannon20_icon.png": "c30b",
	"./ballicon/cannon20ex_icon.png": "96ed",
	"./ballicon/gamma3_icon.png": "b204",
	"./ballicon/gamma3ex_icon.png": "e768",
	"./ballicon/infinity8_icon.png": "98c5",
	"./ballicon/infinity8ex_icon.png": "75b9",
	"./ballicon/jisukuai3_icon.png": "81eb",
	"./ballicon/jisukuaile_icon.png": "a6f6",
	"./ballicon/jisusaiche_icon.png": "7924",
	"./ballicon/jisushishi_icon.png": "2fa9",
	"./ballicon/kl8lhc_icon.png": "ebcb",
	"./ballicon/lucky5_icon.png": "05cc",
	"./ballicon/lucky5ex_icon.png": "1bab",
	"./ballicon/lucky7daily_icon.png": "3108",
	"./ballicon/megamillions_icon.png": "c33c",
	"./ballicon/penta5_icon.png": "4c95",
	"./ballicon/penta5classic_icon.png": "4fba",
	"./ballicon/penta5ex_icon.png": "b6d7",
	"./ballicon/penta_icon.png": "5892",
	"./ballicon/pl3_icon.png": "2a07",
	"./ballicon/pl5_icon.png": "f8f7",
	"./ballicon/pl5daily_icon.png": "3d97",
	"./ballicon/powerball_icon.png": "95e2",
	"./ballicon/qxc_icon.png": "b443",
	"./ballicon/rolling10_icon.png": "5cca",
	"./ballicon/rolling10ex_icon.png": "81c0",
	"./ballicon/sgplhc_icon.png": "2ac3",
	"./ballicon/surfing10classic_icon.png": "d20c",
	"./ballicon/twbg_icon.png": "387d",
	"./ballicon/twbglhc_icon.png": "6c5d",
	"./ballicon/twbgsch_icon.png": "4e46",
	"./ballicon/twbgscq_icon.png": "205b",
	"./ballicon/xglhc_icon.png": "0dd6",
	"./banner.jpg": "3f63",
	"./bg.png": "9f6d",
	"./bn.jpg": "2da0",
	"./disclaimer.png": "b889",
	"./footer_logo.png": "cd41",
	"./global.png": "6352",
	"./home.png": "4a31",
	"./home_banner1.png": "eeee",
	"./home_banner2.png": "00a4",
	"./ico_close_gray.png": "03a4",
	"./icon/about-1.png": "7cf0",
	"./icon/about-2.png": "b68e",
	"./icon/award-symbol.png": "7cb7",
	"./icon/disclaimer-1.png": "b69e",
	"./icon/disclaimer-2.png": "178a",
	"./icon/fire.png": "a74a",
	"./icon/hot.png": "406f",
	"./icon/icon_lottery.png": "35d9",
	"./icon/new.png": "098f",
	"./icon/rules-1.png": "38fe",
	"./icon/rules-2.png": "1687",
	"./icon_lottery.png": "19af",
	"./icon_playback.png": "6a6d",
	"./list-1.png": "dd18",
	"./list-2.png": "a4fc",
	"./logo-1.png": "07d2",
	"./logo.png": "7c04",
	"./lottery_background/azxy10_bg.png": "42d4",
	"./lottery_background/azxy20_bg.png": "8e8c",
	"./lottery_background/azxy5_bg.png": "4aa3",
	"./lottery_background/azxy8_bg.png": "3af8",
	"./lottery_background/cannon20_bg.png": "9ddd",
	"./lottery_background/cannon20ex_bg.png": "a84a",
	"./lottery_background/gamma3_bg.png": "13a1",
	"./lottery_background/gamma3ex_bg.png": "8354",
	"./lottery_background/infinity8_bg.png": "adab",
	"./lottery_background/infinity8ex_bg.png": "c6db",
	"./lottery_background/jisukuai3_bg.png": "df04",
	"./lottery_background/jisukuaile_bg.png": "6fce",
	"./lottery_background/jisusaiche_bg.png": "d2d9",
	"./lottery_background/jisushishi_bg.png": "f460",
	"./lottery_background/kl8lhc_bg.png": "2f48",
	"./lottery_background/lucky5_bg.png": "db53",
	"./lottery_background/lucky5ex_bg.png": "b62e",
	"./lottery_background/lucky7daily_bg.png": "122e",
	"./lottery_background/megamillions_bg.png": "4514",
	"./lottery_background/penta5_bg.png": "66ba",
	"./lottery_background/penta5classic_bg.png": "e727",
	"./lottery_background/penta5ex_bg.png": "890e",
	"./lottery_background/pl3_bg.png": "6f40",
	"./lottery_background/pl5_bg.png": "3592",
	"./lottery_background/pl5daily_bg.png": "921c",
	"./lottery_background/powerball_bg.png": "ac26",
	"./lottery_background/qxc_bg.png": "818b",
	"./lottery_background/rolling10_bg.png": "085c",
	"./lottery_background/rolling10ex_bg.png": "c954",
	"./lottery_background/sgplhc_bg.png": "b4e8",
	"./lottery_background/surfing10classic_bg.png": "439f",
	"./lottery_background/twbg_bg.png": "de05",
	"./lottery_background/twbglhc_bg.png": "81de",
	"./lottery_background/twbgsch_bg.png": "f22a",
	"./lottery_background/twbgscq_bg.png": "4057",
	"./lottery_background/xglhc_bg.png": "0eb8",
	"./megamillions_ad1.png": "3537",
	"./megamillions_ad2.png": "0f60",
	"./mobile_banner.jpg": "48e4",
	"./mobile_popup.png": "cc4c",
	"./moveArrow.png": "836e",
	"./new_img.png": "a297",
	"./pc_banner.jpg": "712d",
	"./pc_popup.png": "a267",
	"./player.png": "21fd",
	"./powerball_ad1.png": "29ca",
	"./powerball_ad2.png": "45e4",
	"./return.png": "3609",
	"./rules.png": "1c03",
	"./side-banner_2.jpg": "ceb4",
	"./star.png": "1596",
	"./sticky.png": "2903",
	"./top_bar-1.svg": "3308",
	"./top_bar-2.png": "33ff",
	"./top_option-1.png": "2347",
	"./top_option-2.png": "b309",
	"./top_option-3.png": "c6c0",
	"./top_option-4.png": "e1e4",
	"./top_option-5.png": "c797",
	"./top_option-6.png": "a5ce",
	"./zhibo-bg.png": "5040"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "95cd";